<template>
    <v-container fluid>
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">Aperture</h2>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog(null)">Nuova apertura</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="lista" :items-per-page="15" density="comfortable">
            <template #[`item.azioni`]="{ item }">
                <v-btn icon variant="text" size="small" @click="apriDialog(item)" title="Modifica">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" color="error" @click="elimina(item)" title="Elimina">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="600" :fullscreen="isMobile">
            <v-card>
                <v-card-title>{{ form.id ? 'Modifica apertura' : 'Nuova apertura' }}</v-card-title>
                <v-card-text>
                    <v-form ref="formRef">
                        <v-select v-model="form.tipoSerramentoId" :items="tipologie" item-title="descrizione"
                            item-value="id" label="Tipologia" :rules="[v => !!v || 'Obbligatorio']" />
                        <v-row>
                            <v-col cols="6">
                                <v-text-field v-model.number="form.numBattenti" type="number" label="Numero battenti"
                                    :rules="[v => v > 0 || 'Obbligatorio']" />
                            </v-col>
                            <v-col cols="6">
                                <v-text-field v-model.number="form.numeroAnte" type="number" label="Numero ante"
                                    :rules="[v => v > 0 || 'Obbligatorio']" />
                            </v-col>
                        </v-row>
                        <v-text-field v-model="form.codice" label="Codice" />
                        <v-text-field v-model="form.descrizione" label="Descrizione (es. 2 ANTE DESTRA AR)"
                            :rules="[v => !!v || 'Obbligatorio']" />
                        <v-text-field v-model.number="form.progOrdinamento" type="number" label="Ordine" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialog = false">Annulla</v-btn>
                    <v-btn color="primary" :loading="salvando" @click="salva">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "AperturePage",

    data() {
        return {
            dialog: false,
            salvando: false,
            form: this.formVuoto(),
            headers: [
                { title: "Tipologia", key: "tipoSerramentoDescrizione" },
                { title: "Battenti", key: "numBattenti" },
                { title: "Ante", key: "numeroAnte" },
                { title: "Codice", key: "codice" },
                { title: "Descrizione", key: "descrizione" },
                { title: "Ordine", key: "progOrdinamento" },
                { title: "", key: "azioni", sortable: false },
            ],
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        lista() {
            return this.$store.getters["aperture/lista"];
        },
        tipologie() {
            return this.$store.getters["tipologie/lista"];
        },
    },

    mounted() {
        this.$store.dispatch("aperture/carica");
        this.$store.dispatch("tipologie/carica");
    },

    methods: {
        formVuoto() {
            return {
                id: null, tipoSerramentoId: null, numBattenti: 1, numeroAnte: 1,
                codice: "", descrizione: "", progOrdinamento: 0,
            };
        },

        apriDialog(item) {
            this.form = item ? { ...item } : this.formVuoto();
            this.dialog = true;
        },

        async salva() {
            if (!this.$refs.formRef.validate()) return;
            this.salvando = true;
            try {
                const dati = {
                    tipoSerramentoId: this.form.tipoSerramentoId,
                    numBattenti: this.form.numBattenti,
                    numeroAnte: this.form.numeroAnte,
                    codice: this.form.codice,
                    descrizione: this.form.descrizione,
                    progOrdinamento: this.form.progOrdinamento,
                };
                if (this.form.id) {
                    await this.$store.dispatch("aperture/aggiorna", { id: this.form.id, dati });
                } else {
                    await this.$store.dispatch("aperture/crea", dati);
                }
                this.dialog = false;
            } catch (error) {
                console.log(error);
            }
            this.salvando = false;
        },

        async elimina(item) {
            try {
                await this.$store.dispatch("aperture/elimina", item.id);
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
